import { ActionIcon, Menu } from '@mantine/core';
import { IconDots, IconTemplate, IconTrash } from '@tabler/icons';
import { FC, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SaveContractTemplateName from '../../Molecules/Contract/SaveContractTemplateName';
import { ConfirmDialog } from '../../Molecules/Dialogs';
import { deleteContract } from '../../Service/restapi/contractService';
import { checkSubmissionsAndDelete } from '../../Service/restapi/shareService';
import { ContractContext } from '../../Service/Context/ContractContextV2';
import { WindowContext } from '../../Service/Context/WindowContext';
import ContractEditorFooter from '../Navigation/phone/ContractEditorFooter';
import InjectableFooter from '../Navigation/phone/InjectableFooter';

const EventContractHeaderActions: FC<{ showPreview: () => void }> = ({ showPreview }) => {
  const navigate = useNavigate();
  const { sm } = useContext(WindowContext);
  const { contract } = useContext(ContractContext);
  const [modalDelete, setModalDelete] = useState(false);
  const [openSaveTemplateNameDialog, setOpenSaveTemplateNameDialog] = useState(false);

  function deleteHandler() {
    if (contract) {
      checkSubmissionsAndDelete(
        'contracts',
        contract.id,
        deleteContract,
        () => {
          if (contract.eventId) {
            navigate(`/events/${contract.eventId}/documents`);
          } else {
            navigate('/documents');
          }
        },
        () => null,
      );
    }
  }

  // function patch(patch: any) {
  //   patchContract(contract.id, patch)
  //     .then((resp) => {
  //       if (resp.ok) {
  //         resp.json().then((contract) => {
  //           handleChange(contract);
  //         });
  //       } else {
  //         console.error('could not patch contract ' + contract.id);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error({ error });
  //       console.error('could not patch contract ' + contract.id);
  //     });
  // }

  return (
    <>
      {sm && (
        <InjectableFooter>
          <ContractEditorFooter
            showPreview={showPreview}
            saveAsTemplate={() => setOpenSaveTemplateNameDialog(true)}
            remove={deleteHandler}
          />
        </InjectableFooter>
      )}
      {!sm && (
        <div>
          <Menu shadow="md" transition="scale-y" position="bottom-end">
            <Menu.Target>
              <ActionIcon>
                <IconDots />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item icon={<IconTemplate size={16} />} onClick={() => setOpenSaveTemplateNameDialog(true)}>
                Vorlage speichern
              </Menu.Item>
              {/* <Menu.Item onClick={toggle}>PDFs beifügen</Menu.Item> */}
              <Menu.Item color="red" onClick={() => setModalDelete(!modalDelete)} icon={<IconTrash size={16} />}>
                Löschen
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          {contract && (
            <SaveContractTemplateName
              contractId={contract.id}
              open={openSaveTemplateNameDialog}
              close={() => {
                setOpenSaveTemplateNameDialog(false);
              }}
            />
          )}

          {/* <ConfigPDFCoverDialog show={show} toggle={toggle} patch={patch} /> */}

          <ConfirmDialog
            text="common.delete.document.confirm"
            subject="common.delete.document.confirm.head"
            open={modalDelete}
            toggle={() => setModalDelete(!modalDelete)}
            handler={() => deleteHandler()}
            // eslint-disable-next-line react/no-children-prop
            children={[]}
            isLoading={false}
            confirmText=""
            disableConfirm={false}
          />
        </div>
      )}
    </>
  );
};

export default EventContractHeaderActions;
